import { styled, Box, BoxProps, alpha } from "@mui/material";

export const EditableBox = styled(Box, {
  name: "EditableBox",
  shouldForwardProp: (prop) => prop !== "focused" && prop !== "error",
})<BoxProps & { focused?: boolean; error?: boolean }>(({ theme, focused, error }) => ({
  paddingLeft: theme.spacing(0.5),
  paddingRight: theme.spacing(0.5),
  borderStyle: "solid",
  borderWidth: 1,
  borderRadius: `${theme.shape.borderRadius}px !important`,
  borderColor: "transparent",
  cursor: "pointer",
  marginLeft: theme.spacing(-0.5), // This counteracts the padding for alignment
  "&:hover": {
    backgroundColor: theme.palette.custom.blue[50],
    borderColor: theme.palette.primary.main,
  },
  // Add focus and error states if they are intended to be used by parent components
  // For now, they are passed but not directly utilized by QuickEditText's internal logic
  ...(focused && {
    backgroundColor: theme.palette.background.paper,
    borderColor: theme.palette.primary.main,
    boxShadow: `0px 0px 4px ${alpha(theme.palette.primary.main, 0.25)}`,
  }),
  ...(error && {
    borderColor: theme.palette.error.main,
  }),
}));
